// istanbul ignore file
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

import {
  initialisePicture as initialisePictureAction,
  setHighQualityLoading as setHighQualityLoadingAction,
  setHighQualityLoaded as setHighQualityLoadedAction,
  setLowQualityLoading as setLowQualityLoadingAction,
  setLowQualityLoaded as setLowQualityLoadedAction,
  setBaseQualityError as setBaseQualityErrorAction,
  setLowQualityRetries as setLowRetriesAction,
  setStopLowQualityRetries as setStopLowQualityRetriesAction,
  resetLowQualityRetries as resetLowQualityRetriesAction,
  setHighQualityRetries as setHighRetriesAction,
  setStopHighQualityRetries as setStopHighQualityRetriesAction,
  setOnlineStatus as setOnlineStatusAction,
  resetHighQualityRetries as resetHighQualityRetriesAction,
  getPicture,
  getBreakpoints,
} from '../modules';

const PictureContainer = ({ childComponent: ChildComponent, ...props }) => (
  <ChildComponent {...R.omit(['pictures'], props)} />
);

PictureContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  picture: getPicture(state, ownProps),
  breakpoints: R.prop('breakpoints', getBreakpoints(state)),
  currentBreakpoint: R.prop('current', getBreakpoints(state)),
});

const mapDispatchToProps = dispatch => ({
  initialisePicture: id => dispatch(initialisePictureAction(id)),
  setHighQualityLoading: (id, isLoading) => dispatch(setHighQualityLoadingAction(id, isLoading)),
  setHighQualityLoaded: id => dispatch(setHighQualityLoadedAction(id)),
  setLowQualityLoading: (id, isLoading) => dispatch(setLowQualityLoadingAction(id, isLoading)),
  setLowQualityLoaded: id => dispatch(setLowQualityLoadedAction(id)),
  setBaseQualityError: id => dispatch(setBaseQualityErrorAction(id)),
  setLowQualityRetries: (id, lowQualityRetries) => dispatch(setLowRetriesAction(id, lowQualityRetries)),
  setStopLowQualityRetries: (id, stopLowQualityRetries) =>
    dispatch(setStopLowQualityRetriesAction(id, stopLowQualityRetries)),
  resetLowQualityRetries: id => dispatch(resetLowQualityRetriesAction(id)),
  setHighQualityRetries: (id, lowQualityRetries) => dispatch(setHighRetriesAction(id, lowQualityRetries)),
  setStopHighQualityRetries: (id, stopLowQualityRetries) =>
    dispatch(setStopHighQualityRetriesAction(id, stopLowQualityRetries)),
  resetHighQualityRetries: id => dispatch(resetHighQualityRetriesAction(id)),
  setOnlineStatus: (id, online) => dispatch(setOnlineStatusAction(id, online)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PictureContainer);
